import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SurveyCard from "../../components/admin-component/survey/SurveyCard";
import TopBar from "../../components/layouts/TopBar";
import { getAllSurveys, surveysSelector } from "../../redux/surveySlice";

const Survey = () => {
  const dispatch = useDispatch();
  const surveys = useSelector(surveysSelector);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    getSurveys(20, 1);
  }, []);

  const getSurveys = (pageSize, pageNum, clientRef, status, startDate, endDate) => {
    dispatch(
      getAllSurveys({ 
        pageSize, 
        pageNum, 
        searchText, 
        clientRef, 
        status,
        startDate,
        endDate
      })
    );
  };

  return (
    <>
      <div className="main-dashboard">
        <div className="mainWrapper">
          <div className="contentMain">
            <TopBar />
            <SurveyCard
              text={searchText}
              setSearchText={(e) => setSearchText(e)}
              survey={surveys}
              getSurveys={getSurveys}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Survey;
